module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eAgjU"))).then(() => parcelRequire('d0iPb'));